import jump from 'jump.js'

const EXPECTED_AD_PLACEMENT_TIME = 3000 // Ballpark estimate of how long ads should take to place
const AFTER_AD_PLACEMENT_REMAINING_BUFFER = 500 // After ads are placed, how long to complete scroll

const easeInOutQuad = (t, b, c, d) => {
  t /= d / 2
  if (t < 1) return c / 2 * t * t + b
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}

// window.$mediavine.web.model.videoSettings.mobile_popout_placement

const preCreateTarget = document.querySelector('.mv-pre-create-target')
// Ensure no initial top padding
preCreateTarget.style.paddingTop = '0'


const handleClick = async (e) => {
  if (!window.$mediavine) {
    return
  }

  e.preventDefault()

  // Add top padding for ad placement once button has been clicked
  preCreateTarget.style.paddingTop = '45px'

  const { target: { hash } } = e
  const anchor = document.querySelector(hash)
  const card = document.querySelector(hash.replace('-jtr', ''))
  const wrapper = document.querySelector(hash)
  let offset = 0
  // Set anchor
  if (!window.mvCreate.jtrClicked) {
    anchor.style.height = '340px'
    anchor.innerHTML = `${anchor.innerHTML}<div class="mv_slot_target" data-slot="recipe"></div>`
    const continueBtn = wrapper.querySelector('.mv-create-jtr-continue')

    if (continueBtn) {
      continueBtn.style.display = 'block'
    }

    if (
      window.$mediavine.web.model &&
      window.$mediavine.web.model.sidebar_btf_sticky_offset
    ) {
      offset = -Math.abs( parseInt(window.$mediavine.web.model.sidebar_btf_sticky_offset) )
    }

    if (
      window.innerWidth < 600 &&
      window.$mediavine.web.model &&
      window.$mediavine.web.model.videoSettings &&
      window.$mediavine.web.model.videoSettings.mobile_popout_placement === 'top_left'
    ) {
      continueBtn.style.textAlign = 'right'
    }

    if (
      window.$mediavine.web &&
      window.$mediavine.web.setContentWaypointDisable
    ) {
      window.$mediavine.web.setContentWaypointDisable(true)
    }
  }

  // Trigger a scroll to the card that should take roughly as long
  // as the ads take to place. Start scroll before initialiazing ads.
  // This returns a promise so we can chain additional actions after
  // the preliminary scroll resolves.

  try {
    // Attempt to render ads. Both these functions return
    // promises, so we can block until they're complete.
    if (!window.mvCreate.jtrClicked) {
      if (window.$mediavine.web.load) {
        await window.$mediavine.web.load()
      }
      if (window.$mediavine.web.renderLazyAds) {
        await window.$mediavine.web.renderLazyAds(wrapper)
      }
    }

  }
  catch(err) {
    // Don't do anything with errors
    console.log(err)
  }
  finally {
    jump(anchor, {
      duration: EXPECTED_AD_PLACEMENT_TIME,
      callback: () => {
        jump(anchor, {
          durration: AFTER_AD_PLACEMENT_REMAINING_BUFFER,
          easing: easeInOutQuad,
          offset,
          callback: () => {
            if (!window.mvCreate.jtrClicked) {
              if (
                window.$mediavine.web &&
                window.$mediavine.web.setContentWaypointDisable
              ) {
                window.$mediavine.web.setContentWaypointDisable(false)
              }
            }
          }
        })
      },
      offset,
      easing: easeInOutQuad,
    })
    window.mvCreate.init(card, 410)
    window.mvCreate.jtrClicked = true
  }
}


const hasJtr = document.querySelector('.mv-create-jtr')
if ( hasJtr ) {
  hasJtr.addEventListener('click', handleClick, false)
}



// WEBPACK FOOTER //
// ./ScrollButton/index.js